import React from 'react'
import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton
} from 'react-admin'

const GraduateProgramList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField source="name" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
)

export default GraduateProgramList
